<template>
  <div class="page">
    <app-title
      :page="'Members'"
      :prehead="organization.name">
      <div slot="content">
        <p class="font-size-4 mb2">Manage account holders.</p>
      </div>
    </app-title>
    <div class="grid grid-columns-3_sm grid-columns-5_lg vh33">
      <section class="p1 subtle grid-column-span-2_sm">
        <h2 class="mb1">Organization members</h2>
        <lw-table :type="'lined'">
          <tr
            v-for="(person, id) of organization.members"
            :key="id">
            <td class="avatar"><img
              v-if="person.avatar"
              :src="person.avatar"
              :alt="person.username + '&rsquo;s avatar'"><svg-avatar v-else/></td>
            <template v-if="id === organization.owner">
              <td>{{ person.username }}</td>
              <td class="align-right font-size-2">Owner</td>
            </template>
            <td
              v-else
              colspan="2">{{ person.username }}</td>
          </tr>
        </lw-table>
      </section>
      <aside
        class="p1 subtle">
        <h3 class="mb1">Invite your team</h3>
        <button
          v-clipboard:copy="query"
          v-clipboard:success="onCopy"
          v-clipboard:error="onError"
          :class="{ 'button--green': copied }"
          type="button"
          class="mb2"
        >
          {{ button }}
        </button>
        <h4>Organization code</h4>
        <p><code>{{ organization.id }}</code></p>
      </aside>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Title from '../common/Title'
import Table from '../livewires/Table'
import Avatar from '../svgs/Avatar.vue'

export default {
  components: {
    appTitle: Title,
    lwTable: Table,
    svgAvatar: Avatar
  },
  data () {
    return {
      button: 'Copy invite link to clipboard',
      copied: false
    }
  },
  computed: {
    ...mapGetters([
      'organization',
      'user'
    ]),
    query () {
      const code = this.organization.id
      const name = this.organization.name
      const stringName = name.replace(' ', '%20')
      let url = 'https://beta.nimber.io'
      if (process.env.NODE_ENV === 'development') {
        url = 'http://localhost:8080'
      }
      return url + '/setup/join/?c=' + code + '&o=' + stringName
    }
  },
  methods: {
    onCopy () {
      this.button = 'Copied!'
      this.copied = true
    },
    onError () {
      this.button = 'Oops. Didn&rsquo;t work. Try again?'
    }
  }
}
</script>

<style scoped>
table td {
  vertical-align: middle;
}
.avatar {
  width: calc(var(--line) * 2);
}
.avatar img {
  display: block;
  max-width: 100%;
  border-radius: var(--radius);
}
</style>
